// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"menuText": "#666666",
	"menuActiveText": "#082dc3",
	"subMenuActiveText": "#f4f4f5",
	"menuBg": "rgba(251, 251, 251, 0.3019607843)",
	"menuHover": "#f5f5f5",
	"subMenuBg": "#1f2d3d",
	"subMenuHover": "#001528",
	"sideBarWidth": "130px",
	"ghost": "#eee"
};
module.exports = exports;
